import { Component } from '@grafikr/components';

import clear from 'utils/clear';
import { NonNullish } from 'utils/nullish-check';

export default Component((node) => {
  const handler = (event: MouseEvent) => {
    const target = event.target;
    const contents = node.querySelector<HTMLElement>('[data-contents]');

    if (!(target instanceof HTMLAnchorElement)) {
      return;
    }

    if (!contents || contents.contains(target)) {
      return;
    }

    const match = node.querySelector<HTMLTemplateElement>(
      `#${target.getAttribute('aria-controls')}`,
    );
    const fallback = NonNullish(contents.querySelector<HTMLElement>('[data-fallback]'));
    const placeholder = NonNullish(
      contents.querySelector<HTMLElement>('[data-contents-placeholder]'),
    );

    event.preventDefault();
    event.stopPropagation();

    if (match) {
      contents.classList.add('is-loading');
    }

    node.querySelectorAll<HTMLAnchorElement>('a.is-active').forEach((anchor) => {
      anchor.classList.remove('is-active');
    });

    target.classList.add('is-active');

    setTimeout(() => {
      clear(placeholder);

      if (!match) {
        fallback.hidden = false;
        placeholder.hidden = true;
      } else {
        fallback.hidden = true;
        placeholder.hidden = false;
        placeholder.appendChild(match.content.cloneNode(true));
      }

      contents.classList.remove('is-loading');
    }, 200);
  };

  node.addEventListener('mouseover', handler);
});
